import React from "react";

import withClass from "../../../hoc/withClass";
import Preloader from "../Preloader/Preloader";

const ModuleIsMounting = (module) => {
  return (
    <div className="page-content text-center">
      <Preloader module={module} />
    </div>
  );
};

export default withClass(ModuleIsMounting, "page bg-white");
